export const navigation = (menu) => {
  const firstPath = menu?.map((items) => {
    return items?.Items?.map((parent) => {
      if (parent?.menutitle !== "ADMIN PANEL") {
        if (parent?.disabled === false && parent?.children?.length === 0 && parent?.menutitle !== "ADMIN PANEL") {
          //console.log("PATH TO NAVIGATE parent =>", parent);
          return parent?.path;
        } else if (parent?.disabled === false && parent?.children?.length > 0 && parent?.menutitle !== "ADMIN PANEL") {
          return parent?.children?.map((child) => {
            //console.log("PATH TO NAVIGATE child=>", child);
            return child?.path;
          });
        }
      }
    });
  });
  const flatMap = firstPath?.flat(2);
  const data = flatMap.filter(function (element) {
    return element !== undefined;
  });
  return data;
};
